module.exports = __webpack_public_path__ + "static/media/unknown-min.bbb73730.jpg";